export const LOAD_REQUERIMENTOS =
  'itbi-cidadao/declaracao-itbi/LOAD_REQUERIMENTOS';
